var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-base',[_c('v-main',[_c('router-view')],1),_c('error-notification'),_c('app-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }